<div class="bg-gray-50 rounded-medium overflow-y-auto p-8 shadow-[0_4px_18px_0_rgba(0,0,0,0.17)] md:w-[540px] "
  *transloco="let t; prefix: 'general-callback-modal'">
  <div class="flex flex-col text-center">
    <div class="flex flex-col gap-2">
      <div class="flex justify-end">
        <div class="flex flex-col">
        </div>
        <button class="p-2 self-start" (click)="close()"><i class="icon-close text-xl"></i></button>
      </div>
      <div class="flex flex-col gap-7">
        <img [src]="imageUrl" />
      </div>
    </div>
  </div>
</div>